import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ReactGA from "react-ga4";
import EmailIcon from "../assets/images/icons/icon-email.png";
import { config } from '../utils/constants';

const REACT_APP_API_URL = config.url.REACT_APP_API_URL; // Ensure this is set in your .env file

const PromotionForm = ({promo_code}) => {
    const [serverMessage, setServerMessage] = useState("");
    const [headingMessage, setHeadingMessage] = useState("Get your discount code here!");
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Formik setup
    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
        },
        validationSchema: Yup.object({
            firstName: Yup.string().trim().required("First name is required"),
            lastName: Yup.string().trim().required("Last name is required"),
            email: Yup.string().email("Invalid email address").required("Email is required"),
        }),
        onSubmit: (values, { resetForm }) => {
            axios
                .post(`${REACT_APP_API_URL}/promo/`, {
                    first_name: values.firstName,
                    last_name: values.lastName,
                    email: values.email,
                    promotion: `${promo_code}`,
                }, { withCredentials: true })
                .then((res) => {

                    setServerMessage(res.data.message); // Show success message
                    console.log(res.data.message);
                    if (res.data.amount)
                        {
                            var heading = "Congratulations!  You now have a " + res.data.amount + " discount!";
                            setHeadingMessage(heading);
                        }
                    setIsSubmitted(true); // Hide form
                    ReactGA.event({
                        category: 'promotion',
                        action: 'promo code',
                        label: `${promo_code}`,
                    });
                })
                .catch((err) => {
                    if (err.response && err.response.status === 409) {
                        setServerMessage(""); // Show thank you message if already subscribed
                        setIsSubmitted(true); // Hide form
                    } else {
                        setServerMessage("An error occurred. Please try again.");
                    }
                });
        },
    });

    return (
        <div>
            {/* Show form only if not submitted */}
                
                <h4 className="mtext-105 cl2 txt-center p-b-30">{headingMessage}</h4>
            {!isSubmitted ? (
                <>
                <form onSubmit={formik.handleSubmit}>
                    {/* First Name Input */}
                    <div className="bor8 m-b-20">
                        <input
                            className="stext-111 cl2 plh3 size-116 p-l-30 p-r-30"
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                    {formik.touched.firstName && formik.errors.firstName ? (
                        <div className="text-danger mt-1 text-sm p-b-20">{formik.errors.firstName}</div>
                    ) : null}

                    {/* Last Name Input */}
                    <div className="bor8 m-b-20">
                        <input
                            className="stext-111 cl2 plh3 size-116 p-l-30 p-r-30"
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                    {formik.touched.lastName && formik.errors.lastName ? (
                        <div className="text-danger mt-1 text-sm p-b-20">{formik.errors.lastName}</div>
                    ) : null}

                    {/* Email Input */}
                    <div className="bor8 m-b-20 how-pos4-parent">
                        <input
                            className="stext-111 cl2 plh3 size-116 p-l-62 p-r-30"
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <img className="how-pos4 pointer-none" src={EmailIcon} alt="Email Icon" />
                    </div>
                    {formik.touched.email && formik.errors.email ? (
                        <div className="text-danger mt-1 text-sm p-b-20">{formik.errors.email}</div>
                    ) : null}

                    {/* Submit Button */}
                     <p className="text-center mb4 p-t-20">We respect your inbox and your privacy. Your information is secure and will only be used to send you valuable hair health insights. No spam, no sharing, ever.</p>
                    <button
                        className="flex-c-m stext-101 cl0 size-121 bg3 bor1 hov-btn3 p-lr-15 trans-04 pointer"
                        type="submit"
                        disabled={formik.isSubmitting}
                    >
                        Submit
                    </button>
                </form>
                </>
            ) : (
                /* Show message only after successful submission */
                <>
                <p className="fs-4 text-center">Use it at checkout.</p>
                <p className="text-success fw-bold fs-4 text-center pt-3">
                {serverMessage}
                </p>
                </>
            )}
        </div>
    );
};

export default PromotionForm;
